import { render, staticRenderFns } from "./attachmentwarningtooltip.vue?vue&type=template&id=075430ea&"
import script from "../../ts/articleattributes/attachmentwarningtooltip.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/attachmentwarningtooltip.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/articleattributes/attachmentwarningtooltip.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports